<template>
    <q-page class="flex flex-center">
        <img alt="Quasar logo" src="../assets/logo.png">
    </q-page>
</template>

<script>
export default {
    name: 'PageHome'
}
</script>

<style>
</style>
